(function () {
  "use strict";

// [module] src/runtime/modules/theme-modern-core/runtime.mjs
function registerThemeModernCoreRuntime() {
  (function () {
    'use strict';
  
    var CART_ENDPOINTS = {
      get: '/cart.js',
      add: '/cart/add.js',
      change: '/cart/change.js',
      update: '/cart/update.js',
      clear: '/cart/clear.js'
    };
  
    var isInitialized = false;
    var collectionRenderRequestId = 0;
    var cartRenderRequestId = 0;
    var cartSectionRefreshTimer = null;
    var productRenderRequestId = 0;
    var productVariantRenderTimer = null;
    var lastRenderedProductVariantBySection = {};
    var collectionRenderAbortController = null;
    var cartRenderAbortController = null;
    var productRenderAbortController = null;
    var sectionRenderCache = {};
    var sectionRenderCacheOrder = [];
    var SECTION_RENDER_CACHE_LIMIT = 40;
    var predictiveSearchCache = {};
    var predictiveSearchCacheOrder = [];
    var PREDICTIVE_SEARCH_CACHE_LIMIT = 50;
    var predictiveSearchStateByForm = new WeakMap();
    var predictiveSearchInstanceId = 0;
    var runtimeI18n = parseRuntimeI18n();
    var cartDrawerState = {
      initialized: false,
      root: null,
      panel: null,
      isOpen: false,
      previouslyFocused: null
    };

    function parseRuntimeFeatureConfig() {
      var rootConfig = window.__sternTheme || {};
      var modernBackports = rootConfig.modernBackports || {};
      var optionalScaffolds = modernBackports.optionalScaffolds || {};
      return {
        enabled: modernBackports.enabled !== false,
        predictiveSearch: modernBackports.predictiveSearch !== false,
        collectionFilters: modernBackports.collectionFilters !== false,
        cartEnhancements: modernBackports.cartEnhancements !== false,
        productEnhancements: modernBackports.productEnhancements !== false,
        accessibilityUtilities: modernBackports.accessibilityUtilities !== false,
        optionalScaffolds: {
          cartDrawer: optionalScaffolds.cartDrawer === true,
          pickupAvailability: optionalScaffolds.pickupAvailability === true,
          localization: optionalScaffolds.localization === true,
          quickOrderList: optionalScaffolds.quickOrderList === true
        }
      };
    }

    function parseRuntimeI18n() {
      var rootConfig = window.__sternTheme || {};
      var i18n = rootConfig.i18n || {};
      var predictiveSearch = i18n.predictiveSearch || {};
      var cart = i18n.cart || {};
      var accessibility = i18n.accessibility || {};
      return {
        predictiveSearch: {
          noResults: String(predictiveSearch.noResults || 'No results found'),
          loading: String(predictiveSearch.loading || 'Loading results'),
          unavailable: String(predictiveSearch.unavailable || 'Search unavailable'),
          results: String(predictiveSearch.results || '__COUNT__ search results'),
          untitled: String(predictiveSearch.untitled || 'Untitled'),
          viewProduct: String(predictiveSearch.viewProduct || 'View product')
        },
        cart: {
          updated: String(cart.updated || 'Cart updated')
        },
        accessibility: {
          nextSlide: String(accessibility.nextSlide || 'Next slide'),
          previousSlide: String(accessibility.previousSlide || 'Previous slide'),
          cartDrawerOpened: String(accessibility.cartDrawerOpened || 'Cart drawer opened'),
          cartDrawerClosed: String(accessibility.cartDrawerClosed || 'Cart drawer closed')
        }
      };
    }

    function resolveRuntimeMessage(namespace, key, replacements) {
      var scope = runtimeI18n[namespace] || {};
      var raw = String(scope[key] || '');
      if (!raw) {
        return '';
      }
      var output = raw;
      var values = replacements || {};
      Object.keys(values).forEach(function (token) {
        var value = String(values[token]);
        output = output.replace(new RegExp('__' + token.toUpperCase() + '__', 'g'), value);
        output = output.replace(new RegExp('\\{\\{\\s*' + token + '\\s*\\}\\}', 'g'), value);
      });
      return output;
    }

    var runtimeFeatureConfig = parseRuntimeFeatureConfig();

    function isFeatureEnabled(featureName) {
      if (!runtimeFeatureConfig.enabled) {
        return false;
      }
      return runtimeFeatureConfig[featureName] !== false;
    }

    function isAbortError(error) {
      if (!error) {
        return false;
      }
      if (error.name === 'AbortError' || error.code === 20) {
        return true;
      }
      var message = String(error.message || '');
      return /aborted|aborterror/i.test(message);
    }

    function clearAbortController(refName) {
      if (refName === 'collection') {
        collectionRenderAbortController = null;
      } else if (refName === 'cart') {
        cartRenderAbortController = null;
      } else if (refName === 'product') {
        productRenderAbortController = null;
      }
    }

    function setCachedValue(cacheStore, orderStore, key, value, maxSize) {
      if (!key) {
        return;
      }
      if (!(key in cacheStore)) {
        orderStore.push(key);
      }
      cacheStore[key] = value;
      while (orderStore.length > maxSize) {
        var oldestKey = orderStore.shift();
        delete cacheStore[oldestKey];
      }
    }

    function getCachedValue(cacheStore, key) {
      if (!key) {
        return null;
      }
      if (!(key in cacheStore)) {
        return null;
      }
      return cacheStore[key];
    }

    function buildSectionCacheKey(sectionId, requestUrl) {
      return sectionId + '::' + requestUrl.pathname + '?' + requestUrl.searchParams.toString();
    }

    function captureFocusDescriptor(node) {
      if (!(node instanceof window.HTMLElement)) {
        return null;
      }

      var descriptor = {};
      if (node.id) {
        descriptor.id = node.id;
      }

      var name = node.getAttribute('name');
      if (name) {
        descriptor.name = name;
      }

      if (
        node instanceof window.HTMLInputElement ||
        node instanceof window.HTMLSelectElement ||
        node instanceof window.HTMLTextAreaElement
      ) {
        descriptor.value = node.value;
      }

      if (node instanceof window.HTMLInputElement) {
        descriptor.type = node.type || 'text';
      }

      return descriptor;
    }

    function restoreFocusFromDescriptor(sectionContainer, descriptor) {
      if (!descriptor || !(sectionContainer instanceof window.HTMLElement)) {
        return;
      }

      var focusNode = null;
      if (descriptor.id) {
        var byId = document.getElementById(descriptor.id);
        if (byId && sectionContainer.contains(byId)) {
          focusNode = byId;
        }
      }

      if (!focusNode && descriptor.name) {
        var namedNodes = sectionContainer.querySelectorAll('[name]');
        Array.prototype.some.call(namedNodes, function (node) {
          if (!(node instanceof window.HTMLElement)) {
            return false;
          }
          if (node.getAttribute('name') !== descriptor.name) {
            return false;
          }
          if (descriptor.value === undefined || String(node.value || '') === String(descriptor.value || '')) {
            focusNode = node;
            return true;
          }
          return false;
        });
      }

      if (!focusNode || typeof focusNode.focus !== 'function') {
        return;
      }

      try {
        focusNode.focus({ preventScroll: true });
      } catch (error) {
        focusNode.focus();
      }
    }

    function getOrCreateLiveRegion(id) {
      var region = document.getElementById(id);
      if (region) {
        return region;
      }
      region = document.createElement('div');
      region.id = id;
      region.setAttribute('aria-live', 'polite');
      region.setAttribute('aria-atomic', 'true');
      region.style.position = 'absolute';
      region.style.width = '1px';
      region.style.height = '1px';
      region.style.padding = '0';
      region.style.margin = '-1px';
      region.style.overflow = 'hidden';
      region.style.clip = 'rect(0, 0, 0, 0)';
      region.style.border = '0';
      document.body.appendChild(region);
      return region;
    }

    function announceLiveRegion(id, message) {
      if (!message) {
        return;
      }
      var region = getOrCreateLiveRegion(id);
      region.textContent = '';
      window.setTimeout(function () {
        region.textContent = String(message);
      }, 20);
    }
  
    function request(url, options) {
      var config = options || {};
      var responseType = config.responseType || 'json';
      var headers = {};
      if (config.headers && typeof config.headers === 'object') {
        Object.keys(config.headers).forEach(function (headerName) {
          headers[headerName] = config.headers[headerName];
        });
      }
      delete config.responseType;
      if (!headers['Accept']) {
        headers['Accept'] = responseType === 'section' ? '*/*' : 'application/json';
      }
      config.headers = headers;
      config.credentials = 'same-origin';
      var fetchFn = window.__themeNativeFetch || window.fetch;
      return fetchFn.call(window, url, config).then(function (response) {
        if (!response.ok) {
          return response.text().then(function (body) {
            throw new Error('Request failed (' + response.status + '): ' + body);
          });
        }
        if (responseType === 'section') {
          return response.text().then(function (body) {
            var normalizedBody = String(body || '').trim();
            if (!normalizedBody) {
              return null;
            }
            try {
              return JSON.parse(normalizedBody);
            } catch (error) {
              return normalizedBody;
            }
          });
        }
        return response.json();
      });
    }
  
    function toFormDataPayload(input) {
      if (input instanceof window.FormData) {
        return input;
      }
      var formData = new window.FormData();
      if (!input || typeof input !== 'object') {
        return formData;
      }
      Object.keys(input).forEach(function (key) {
        if (input[key] !== undefined && input[key] !== null) {
          formData.append(key, input[key]);
        }
      });
      return formData;
    }
  
    var api = {
      cart: {
        get: function () {
          return request(CART_ENDPOINTS.get);
        },
        addItem: function (variantId, quantity, properties) {
          var payload = {
            id: variantId,
            quantity: quantity || 1
          };
          if (properties && typeof properties === 'object') {
            payload.properties = properties;
          }
          return request(CART_ENDPOINTS.add, {
            method: 'POST',
            body: toFormDataPayload(payload)
          });
        },
        add: function (payload) {
          return request(CART_ENDPOINTS.add, {
            method: 'POST',
            body: toFormDataPayload(payload)
          });
        },
        addFromForm: function (formElement) {
          return request(CART_ENDPOINTS.add, {
            method: 'POST',
            body: new window.FormData(formElement)
          });
        },
        change: function (payload) {
          return request(CART_ENDPOINTS.change, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify(payload || {})
          });
        },
        update: function (payload) {
          return request(CART_ENDPOINTS.update, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify(payload || {})
          });
        },
        clear: function () {
          return request(CART_ENDPOINTS.clear, {
            method: 'POST'
          });
        },
        fetchSections: function (sectionIds) {
          var ids = Array.isArray(sectionIds) ? sectionIds.filter(Boolean) : [];
          if (!ids.length) {
            return Promise.resolve(null);
          }
          var params = new window.URLSearchParams();
          params.set('sections', ids.join(','));
          return request('/?' + params.toString(), {
            responseType: 'section'
          });
        }
      },
      predictiveSearch: function (query, options) {
        var searchQuery = (query || '').trim();
        if (!searchQuery) {
          return Promise.resolve(null);
        }
  
        var opts = options || {};
        var types = opts.types || ['product'];
        var limit = String(opts.limit || 6);
        var params = new window.URLSearchParams();
        params.set('q', searchQuery);
        params.set('resources[type]', types.join(','));
        params.set('resources[limit]', limit);
        params.set('resources[limit_scope]', 'each');
        params.set('resources[options][unavailable_products]', 'hide');
        params.set('resources[options][fields]', 'title,product_type,variants.title');

        return request('/search/suggest.json?' + params.toString(), {
          signal: opts.signal
        });
      }
    };
  
    function emit(name, detail) {
      window.dispatchEvent(new window.CustomEvent(name, { detail: detail || {} }));
    }

    function decodeHtmlEntities(value) {
      if (typeof value !== 'string' || value.indexOf('&') === -1) {
        return String(value || '');
      }
      var textarea = document.createElement('textarea');
      textarea.innerHTML = value;
      return textarea.value;
    }
  
    function formatMoney(cents) {
      var rawCents = cents;
      if (typeof rawCents === 'string') {
        rawCents = rawCents.replace('.', '');
      }

      var moneyFormat = decodeHtmlEntities(
        (window.__sternTheme && window.__sternTheme.moneyFormat) || '${{amount}}'
      );
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var placeholderMatch = moneyFormat.match(placeholderRegex);

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number === null) {
          return '0';
        }

        var amount = (Number(number) / 100).toFixed(precision);
        var parts = amount.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
      }

      if (!placeholderMatch) {
        return formatWithDelimiters(rawCents, 2);
      }

      var placeholder = placeholderMatch[1];
      var value = '';
      switch (placeholder) {
        case 'amount':
          value = formatWithDelimiters(rawCents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(rawCents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(rawCents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(rawCents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(rawCents, 0, ' ');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(rawCents, 2, "'");
          break;
        default:
          value = formatWithDelimiters(rawCents, 2);
          break;
      }

      return moneyFormat.replace(placeholderRegex, value);
    }
  
    function setCartCountInDom(itemCount) {
      var count = Number(itemCount || 0);
      var badgeNodes = document.querySelectorAll('.cart_count_number, [class~="m\\:cart-qty"]');
      Array.prototype.forEach.call(badgeNodes, function (node) {
        node.textContent = String(count);
        if (count > 0) {
          node.style.display = '';
        } else {
          node.style.display = 'none';
        }
      });
    }
  
    function syncCartCount() {
      return api.cart.get()
        .then(function (cart) {
          setCartCountInDom(cart.item_count);
          emit('theme:cart:updated', { cart: cart });
          return cart;
        })
        .catch(function () {
          return null;
        });
    }
  
    function getRequestUrl(requestInput) {
      if (!requestInput) {
        return '';
      }
      if (typeof requestInput === 'string') {
        return requestInput;
      }
      if (requestInput && typeof requestInput.url === 'string') {
        return requestInput.url;
      }
      return String(requestInput || '');
    }

    function isCartMutationUrl(url) {
      var normalizedUrl = String(url || '');
      return (
        normalizedUrl.indexOf('/cart/add.js') !== -1 ||
        normalizedUrl.indexOf('/cart/change.js') !== -1 ||
        normalizedUrl.indexOf('/cart/update.js') !== -1 ||
        normalizedUrl.indexOf('/cart/clear.js') !== -1
      );
    }

    function isCartAddFormAction(actionValue) {
      var rawAction = String(actionValue || '');
      if (!rawAction) {
        return false;
      }

      try {
        var parsedAction = new URL(rawAction, window.location.origin);
        var normalizedPath = parsedAction.pathname.replace(/\/+$/, '');
        return normalizedPath === '/cart/add' || /\/cart\/add$/.test(normalizedPath);
      } catch (error) {
        var fallbackPath = rawAction.split('?')[0].replace(/^https?:\/\/[^/]+/i, '').replace(/\/+$/, '');
        return fallbackPath === '/cart/add' || /\/cart\/add$/.test(fallbackPath);
      }
    }
  
    function patchNetworkHooks() {
      if (window.__themeModernNetworkPatched) {
        return;
      }
      window.__themeModernNetworkPatched = true;
  
      var originalFetch = window.fetch;
      window.fetch = function () {
        var args = Array.prototype.slice.call(arguments);
        var normalizedUrl = getRequestUrl(args[0]);
        return originalFetch.apply(window, args).then(function (response) {
          if (isFeatureEnabled('cartEnhancements') && isCartMutationUrl(normalizedUrl)) {
            window.setTimeout(syncCartCount, 100);
            scheduleCartSectionRefresh();
          }
          return response;
        });
      };
  
      if (window.axios && typeof window.axios.post === 'function' && !window.__themeModernAxiosPatched) {
        window.__themeModernAxiosPatched = true;
        var originalAxiosPost = window.axios.post.bind(window.axios);
        window.axios.post = function (url, data, config) {
          return originalAxiosPost(url, data, config).then(function (result) {
            if (isFeatureEnabled('cartEnhancements') && isCartMutationUrl(url)) {
              window.setTimeout(syncCartCount, 100);
              scheduleCartSectionRefresh();
            }
            return result;
          });
        };
      }
    }
  
    function scheduleCartSectionRefresh() {
      var hasCartPageSection = !!document.querySelector('form[name="cart"]');
      var hasCartDrawerSection = !!document.getElementById('shopify-section-cart-drawer');
      if (!hasCartPageSection && !hasCartDrawerSection) {
        return;
      }
      if (cartSectionRefreshTimer) {
        window.clearTimeout(cartSectionRefreshTimer);
      }
      cartSectionRefreshTimer = window.setTimeout(function () {
        refreshCartSection({
          hardReloadOnError: false,
          sectionId: hasCartPageSection ? undefined : (hasCartDrawerSection ? 'cart-drawer' : undefined)
        });
        cartSectionRefreshTimer = null;
      }, 140);
    }
  
    function bindFallbackAddToCart() {
      document.addEventListener('submit', function (event) {
        var form = event.target;
        if (!(form instanceof window.HTMLFormElement)) {
          return;
        }
        if (!isCartAddFormAction(form.getAttribute('action') || form.action)) {
          return;
        }
  
        event.preventDefault();
        api.cart.addFromForm(form)
          .then(function (payload) {
            emit('theme:cart:added', { response: payload, form: form });
            syncCartCount();
            scheduleCartSectionRefresh();
            if (runtimeFeatureConfig.optionalScaffolds && runtimeFeatureConfig.optionalScaffolds.cartDrawer) {
              emit('theme:cart-drawer:request-open', { source: 'add-to-cart', form: form });
            }
            return true;
          })
          .catch(function (error) {
            emit('theme:cart:error', { error: error, form: form });
            if (window.console && typeof window.console.error === 'function') {
              window.console.error('[theme-modern] add to cart failed', error);
            }
            // Fallback to native form submission when AJAX add-to-cart fails.
            if (form.getAttribute('data-theme-native-submit') === '1') {
              return;
            }
            form.setAttribute('data-theme-native-submit', '1');
            form.submit();
          });
      }, true);
    }
  
    function parseCommonEnv() {
      var node = document.getElementById('bbg-common-env');
      if (!node || !node.textContent) {
        return null;
      }
      try {
        return JSON.parse(node.textContent);
      } catch (error) {
        return null;
      }
    }
  
    function setAddButtonAvailability(form, isAvailable, isPreOrder) {
      var addTargets = form.querySelectorAll('input[name="add"], #add, #add-bundle');
      Array.prototype.forEach.call(addTargets, function (node) {
        if (!(node instanceof window.HTMLElement)) {
          return;
        }
        if (isAvailable) {
          node.removeAttribute('disabled');
          if (node instanceof window.HTMLInputElement && node.type === 'submit') {
            if(isPreOrder){
              node.value = isPreOrder;
            }
            else {
              node.value = 'Add to cart';
            }
          }
          node.setAttribute('aria-disabled', 'false');
        } else {
          node.setAttribute('disabled', 'disabled');
          if (node instanceof window.HTMLInputElement && node.type === 'submit') {
            node.value = 'Sold Out';
          }
          node.setAttribute('aria-disabled', 'true');
        }
      });
    }

    function normalizeProductQuantityInputs(rootNode) {
      var scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
      var quantityInputs = scope.querySelectorAll('form[name="add_to_cart"] input[name="quantity"]');
      Array.prototype.forEach.call(quantityInputs, function (inputNode) {
        var min = Number(inputNode.getAttribute('min') || '1');
        var value = Number(inputNode.value);
        var nextValue = Number.isFinite(value) ? value : min;
        if (nextValue < min) {
          nextValue = min;
        }
        inputNode.value = String(nextValue);
      });
    }
  
    function updateVariantImageFromEnv(env, variantId) {
      if (!env || !env.variants || !Array.isArray(env.variants)) {
        return;
      }
      var numericVariantId = Number(variantId);
      var match = env.variants.find(function (variant) {
        return Number(variant.id) === numericVariantId;
      });
      if (!match || !match.image) {
        return;
      }
      var featuredImg = document.querySelector('.m\\:featured-image img');
      if (!featuredImg) {
        return;
      }
      if (match.image.thumbnail_src) {
        featuredImg.setAttribute('src', match.image.thumbnail_src);
      }
      if (match.image.thumbnail_srcset) {
        featuredImg.setAttribute('srcset', match.image.thumbnail_srcset);
      }
    }
  
    function shouldRenderProductSectionForVariant(selectElement) {
      if (!(selectElement instanceof window.HTMLSelectElement)) {
        return false;
      }
      if (window.location.pathname.indexOf('/products/') === -1) {
        return false;
      }
      if (!selectElement.closest('form[name="add_to_cart"]')) {
        return false;
      }
      return !!getSectionIdFromNode(selectElement);
    }
  
    function syncVariantInHistory(variantId) {
      if (!variantId) {
        return;
      }
      var nextUrl = new window.URL(window.location.href);
      nextUrl.searchParams.set('variant', String(variantId));
      window.history.replaceState(
        window.history.state,
        '',
        nextUrl.pathname + nextUrl.search + nextUrl.hash
      );
    }
  
    function replaceProductFragment(sectionContainer, renderedRoot, fragmentName) {
      var selector = '[data-product-section-fragment="' + fragmentName + '"]';
      var currentNode = sectionContainer.querySelector(selector);
      var nextNode = renderedRoot.querySelector(selector);
      if (!currentNode || !nextNode) {
        return false;
      }
  
      currentNode.replaceWith(nextNode.cloneNode(true));
      return true;
    }
  
    function renderProductSectionForVariant(options) {
      var opts = options || {};
      var sectionId = opts.sectionId || 'main-product';
      var variantId = String(opts.variantId || '');
      var sectionContainer = document.getElementById('shopify-section-' + sectionId);
  
      if (!variantId || !sectionContainer) {
        return Promise.resolve(false);
      }
  
      productRenderRequestId += 1;
      var requestId = productRenderRequestId;
      sectionContainer.classList.add('is-loading');
      sectionContainer.setAttribute('aria-busy', 'true');
      var focusDescriptor = opts.focusDescriptor || captureFocusDescriptor(document.activeElement);
  
      var requestUrl = new window.URL(window.location.pathname + window.location.search, window.location.origin);
      requestUrl.searchParams.set('variant', variantId);
      requestUrl.searchParams.set('sections', sectionId);

      if (productRenderAbortController && typeof productRenderAbortController.abort === 'function') {
        productRenderAbortController.abort();
      }
      productRenderAbortController = typeof window.AbortController === 'function'
        ? new window.AbortController()
        : null;
  
      function cleanup() {
        if (requestId === productRenderRequestId) {
          sectionContainer.classList.remove('is-loading');
          sectionContainer.removeAttribute('aria-busy');
        }
      }
  
      return request(requestUrl.pathname + '?' + requestUrl.searchParams.toString(), {
        signal: productRenderAbortController ? productRenderAbortController.signal : undefined,
        responseType: 'section'
      })
        .then(function (payload) {
          if (requestId !== productRenderRequestId) {
            cleanup();
            return false;
          }
  
          var renderedSection = payload && payload[sectionId];
          if (!renderedSection) {
            throw new Error('Missing product section payload: ' + sectionId);
          }
  
          var renderedRoot = document.createElement('div');
          renderedRoot.innerHTML = renderedSection;
  
          // Destroy existing BlobSelect instances before DOM replacement
          // to prevent leaked setInterval watchers on detached nodes
          ['media', 'details'].forEach(function (fragmentName) {
            var currentFragment = sectionContainer.querySelector(
              '[data-product-section-fragment="' + fragmentName + '"]'
            );
            if (currentFragment) {
              var oldSelects = currentFragment.querySelectorAll('select[data-blobselect]');
              Array.prototype.forEach.call(oldSelects, function (sel) {
                if (sel.blobSelect && typeof sel.blobSelect.destroy === 'function') {
                  try { sel.blobSelect.destroy(); } catch (e) {}
                }
              });
            }
          });

          var replacedMedia = replaceProductFragment(sectionContainer, renderedRoot, 'media');
          var replacedDetails = replaceProductFragment(sectionContainer, renderedRoot, 'details');
          var replacedRelatedProducts = replaceProductFragment(sectionContainer, renderedRoot, 'related-products');
          if (!replacedMedia && !replacedDetails && !replacedRelatedProducts) {
            sectionContainer.innerHTML = extractSectionInnerHtml(renderedSection, sectionId);
          }

          restoreFocusFromDescriptor(sectionContainer, focusDescriptor);
          normalizeProductQuantityInputs(sectionContainer);
  
          lastRenderedProductVariantBySection[sectionId] = variantId;
          syncVariantInHistory(variantId);
  
          if (window.theme && typeof window.theme.initModules === 'function') {
            window.theme.initModules(sectionContainer);
          }

          // Reinitialize BlobSelect on new select elements after fragment replacement
          var blobSelects = sectionContainer.querySelectorAll('select[data-blobselect]');
          Array.prototype.forEach.call(blobSelects, function (sel) {
            if (sel.blobSelect && typeof sel.blobSelect.init === 'function') {
              try { sel.blobSelect.init(); } catch (e) {}
            }
          });

          sectionContainer.dispatchEvent(new window.CustomEvent('shopify:section:load', {
            bubbles: true,
            detail: { sectionId: sectionId }
          }));
  
          emit('theme:product:section:rendered', {
            sectionId: sectionId,
            variantId: variantId
          });
          clearAbortController('product');
          cleanup();
          return true;
        })
        .catch(function (error) {
          if (isAbortError(error)) {
            cleanup();
            return false;
          }
          if (window.console && typeof window.console.error === 'function') {
            console.error('[theme-modern] product section render failed:', error);
          }
          cleanup();
          clearAbortController('product');
          emit('theme:product:section:error', {
            sectionId: sectionId,
            variantId: variantId,
            error: error
          });
          return false;
        });
    }
  
    function bindVariantGuards() {
      var env = parseCommonEnv();
  
      function applyVariantState(selectElement, options) {
        var opts = options || {};
        if (!(selectElement instanceof window.HTMLSelectElement)) {
          return;
        }
        if (selectElement.name !== 'id') {
          return;
        }
        // Use name="add_to_cart" (not action="/cart/add") so this still matches
        // after Google Analytics Linker decorates the form's action with ?_gl=...
        // on submit. Without this, every post-ATC variant change returns early here
        // and silently skips section render / URL sync / availability update.
        var form = selectElement.closest('form[name="add_to_cart"]');
        if (!form) {
          return;
        }
  
        var selectedOption = selectElement.options[selectElement.selectedIndex];
        var availableAttr = selectedOption ? selectedOption.getAttribute('data-available') : null;
        var isAvailable = availableAttr !== 'false';
        var preOrderAttr = selectedOption ? selectedOption.getAttribute('data-preorder') : null;
        setAddButtonAvailability(form, isAvailable, preOrderAttr);
        updateVariantImageFromEnv(env, selectElement.value);
        emit('theme:variant:change', {
          variantId: selectElement.value,
          available: isAvailable
        });
  
        var sectionId = getSectionIdFromNode(selectElement);
        var selectedVariantId = String(selectElement.value || '');
        if (sectionId && selectedVariantId && !opts.skipSectionRender) {
          var lastRenderedVariantId = lastRenderedProductVariantBySection[sectionId];
          if (
            shouldRenderProductSectionForVariant(selectElement) &&
            lastRenderedVariantId !== selectedVariantId
          ) {
            window.clearTimeout(productVariantRenderTimer);
            productVariantRenderTimer = window.setTimeout(function () {
              renderProductSectionForVariant({
                sectionId: sectionId,
                variantId: selectedVariantId,
                focusDescriptor: captureFocusDescriptor(selectElement)
              });
              productVariantRenderTimer = null;
            }, 120);
          }
        } else if (sectionId && selectedVariantId) {
          lastRenderedProductVariantBySection[sectionId] = selectedVariantId;
        }
      }
  
      document.addEventListener('change', function (event) {
        var target = event.target;
        applyVariantState(target, { skipSectionRender: false });
      });
  
      var variantSelects = document.querySelectorAll('form[name="add_to_cart"] select[name="id"]');
      Array.prototype.forEach.call(variantSelects, function (selectElement) {
        applyVariantState(selectElement, { skipSectionRender: true });
      });
      normalizeProductQuantityInputs(document);
    }
  
    function createPredictivePanel(form) {
      var existing = form.querySelector('.theme-predictive-search');
      if (existing) {
        return existing;
      }
  
      var panel = document.createElement('div');
      panel.className = 'theme-predictive-search';
      panel.setAttribute('role', 'listbox');
      panel.style.position = 'absolute';
      panel.style.left = '0';
      panel.style.right = '0';
      panel.style.top = '100%';
      panel.style.marginTop = '8px';
      panel.style.background = '#fff';
      panel.style.border = '1px solid #e6e6e6';
      panel.style.boxShadow = '0 8px 24px rgba(0,0,0,.08)';
      panel.style.zIndex = '60';
      panel.style.display = 'none';
      panel.style.maxHeight = '420px';
      panel.style.overflowY = 'auto';
      panel.style.padding = '8px 0';
  
      if (window.getComputedStyle(form).position === 'static') {
        form.style.position = 'relative';
      }
      form.appendChild(panel);
      return panel;
    }

    function createPredictiveStatusNode(form, instanceId) {
      var existing = form.querySelector('.theme-predictive-search-status');
      if (existing) {
        return existing;
      }

      var status = document.createElement('div');
      status.className = 'theme-predictive-search-status';
      status.id = 'theme-predictive-search-status-' + instanceId;
      status.setAttribute('aria-live', 'polite');
      status.setAttribute('aria-atomic', 'true');
      status.style.position = 'absolute';
      status.style.width = '1px';
      status.style.height = '1px';
      status.style.padding = '0';
      status.style.margin = '-1px';
      status.style.overflow = 'hidden';
      status.style.clip = 'rect(0, 0, 0, 0)';
      status.style.border = '0';
      form.appendChild(status);
      return status;
    }

    function setPredictiveStatus(state, message) {
      if (!state || !state.statusNode || !message) {
        return;
      }
      state.statusNode.textContent = '';
      window.setTimeout(function () {
        state.statusNode.textContent = String(message);
      }, 10);
    }

    function closePredictivePanel(state, clearResults) {
      if (!state || !state.panelNode) {
        return;
      }
      if (clearResults) {
        state.panelNode.innerHTML = '';
      }
      state.panelNode.style.display = 'none';
      state.panelNode.setAttribute('aria-hidden', 'true');
      state.activeIndex = -1;
      state.optionNodes = [];
      if (state.inputNode) {
        state.inputNode.setAttribute('aria-expanded', 'false');
        state.inputNode.removeAttribute('aria-activedescendant');
      }
    }

    function setPredictiveSelection(state, nextIndex) {
      if (!state || !state.optionNodes || !state.optionNodes.length) {
        return;
      }

      var optionCount = state.optionNodes.length;
      var index = nextIndex;
      if (index < 0) {
        index = optionCount - 1;
      } else if (index >= optionCount) {
        index = 0;
      }

      state.optionNodes.forEach(function (node, optionIndex) {
        var isSelected = optionIndex === index;
        node.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        node.style.background = isSelected ? '#f6f6f6' : '';
      });

      state.activeIndex = index;
      if (state.inputNode) {
        state.inputNode.setAttribute('aria-activedescendant', state.optionNodes[index].id);
      }
    }

    function getPredictiveCacheKey(query) {
      return String(query || '').trim().replace(/\s+/g, ' ').toLowerCase();
    }

    function isSearchForm(form) {
      if (!(form instanceof window.HTMLFormElement)) {
        return false;
      }
      var action = form.getAttribute('action') || '';
      if (!action) {
        return false;
      }
      try {
        var actionUrl = new window.URL(action, window.location.origin);
        return /\/search\/?$/.test(actionUrl.pathname);
      } catch (error) {
        return false;
      }
    }

    function getPredictiveState(form, inputNode) {
      var existing = predictiveSearchStateByForm.get(form);
      if (existing) {
        existing.inputNode = inputNode;
        return existing;
      }

      predictiveSearchInstanceId += 1;
      var panelNode = createPredictivePanel(form);
      var statusNode = createPredictiveStatusNode(form, predictiveSearchInstanceId);
      if (!panelNode.id) {
        panelNode.id = 'theme-predictive-search-panel-' + predictiveSearchInstanceId;
      }

      inputNode.setAttribute('aria-controls', panelNode.id);
      inputNode.setAttribute('aria-expanded', 'false');
      inputNode.setAttribute('aria-autocomplete', 'list');
      inputNode.setAttribute('aria-describedby', statusNode.id);

      var state = {
        instanceId: predictiveSearchInstanceId,
        inputNode: inputNode,
        panelNode: panelNode,
        statusNode: statusNode,
        activeIndex: -1,
        optionNodes: [],
        activeRequestId: 0,
        debounceTimer: null,
        abortController: null
      };

      form.addEventListener('focusout', function () {
        window.setTimeout(function () {
          if (!form.contains(document.activeElement)) {
            closePredictivePanel(state, false);
          }
        }, 0);
      });

      predictiveSearchStateByForm.set(form, state);
      return state;
    }

    function renderPredictiveResults(state, result) {
      if (!state || !state.panelNode) {
        return;
      }

      var panel = state.panelNode;
      panel.innerHTML = '';
      var resources = result && result.resources && result.resources.results;
      var products = resources && resources.products ? resources.products : [];

      if (!products.length) {
        closePredictivePanel(state, true);
        setPredictiveStatus(state, resolveRuntimeMessage('predictiveSearch', 'noResults'));
        return;
      }

      products.forEach(function (product, index) {
        var anchor = document.createElement('a');
        anchor.href = product.url;
        anchor.id = 'theme-predictive-option-' + state.instanceId + '-' + index;
        anchor.setAttribute('data-predictive-option', '');
        anchor.setAttribute('role', 'option');
        anchor.setAttribute('aria-selected', 'false');
        anchor.style.display = 'block';
        anchor.style.padding = '10px 16px';
        anchor.style.textDecoration = 'none';
        anchor.style.color = '#111';
        anchor.style.borderBottom = '1px solid #f2f2f2';

        var title = document.createElement('div');
        title.textContent = product.title || resolveRuntimeMessage('predictiveSearch', 'untitled');
        title.style.fontWeight = '600';
        title.style.fontSize = '14px';
        title.style.lineHeight = '1.4';

        var meta = document.createElement('div');
        meta.style.fontSize = '12px';
        meta.style.color = '#555';
        meta.style.marginTop = '4px';
        if (typeof product.price === 'number') {
          meta.textContent = formatMoney(product.price);
        } else {
          meta.textContent = resolveRuntimeMessage('predictiveSearch', 'viewProduct');
        }

        anchor.appendChild(title);
        anchor.appendChild(meta);
        panel.appendChild(anchor);
      });

      state.optionNodes = Array.prototype.slice.call(panel.querySelectorAll('[data-predictive-option]'));
      state.activeIndex = -1;
      panel.style.display = '';
      panel.setAttribute('aria-hidden', 'false');
      if (state.inputNode) {
        state.inputNode.setAttribute('aria-expanded', 'true');
      }
      setPredictiveStatus(
        state,
        resolveRuntimeMessage('predictiveSearch', 'results', { count: products.length })
      );
    }

    function bindPredictiveSearch() {
      document.addEventListener('input', function (event) {
        var input = event.target;
        if (!(input instanceof window.HTMLInputElement)) {
          return;
        }
        if (input.type !== 'search') {
          return;
        }

        var form = input.closest('form');
        if (!isSearchForm(form)) {
          return;
        }

        var state = getPredictiveState(form, input);
        var term = String(input.value || '').trim();
        window.clearTimeout(state.debounceTimer);

        if (state.abortController && typeof state.abortController.abort === 'function') {
          state.abortController.abort();
        }

        if (term.length < 2) {
          closePredictivePanel(state, true);
          return;
        }

        state.debounceTimer = window.setTimeout(function () {
          var cacheKey = getPredictiveCacheKey(term);
          var cachedResult = getCachedValue(predictiveSearchCache, cacheKey);
          if (cachedResult) {
            renderPredictiveResults(state, cachedResult);
            emit('theme:search:predictive:results', {
              query: term,
              result: cachedResult,
              cache: true
            });
            return;
          }

          state.activeRequestId += 1;
          var requestId = state.activeRequestId;
          state.abortController = typeof window.AbortController === 'function'
            ? new window.AbortController()
            : null;
          setPredictiveStatus(state, resolveRuntimeMessage('predictiveSearch', 'loading'));

          api.predictiveSearch(term, {
            types: ['product'],
            limit: 6,
            signal: state.abortController ? state.abortController.signal : undefined
          })
            .then(function (result) {
              if (requestId !== state.activeRequestId) {
                return;
              }
              setCachedValue(
                predictiveSearchCache,
                predictiveSearchCacheOrder,
                cacheKey,
                result,
                PREDICTIVE_SEARCH_CACHE_LIMIT
              );
              renderPredictiveResults(state, result);
              emit('theme:search:predictive:results', {
                query: term,
                result: result,
                cache: false
              });
            })
            .catch(function (error) {
              if (isAbortError(error)) {
                return;
              }
              closePredictivePanel(state, false);
              setPredictiveStatus(state, resolveRuntimeMessage('predictiveSearch', 'unavailable'));
            });
        }, 220);
      });

      document.addEventListener('keydown', function (event) {
        var input = event.target;
        if (!(input instanceof window.HTMLInputElement) || input.type !== 'search') {
          return;
        }
        var form = input.closest('form');
        if (!isSearchForm(form)) {
          return;
        }
        var state = getPredictiveState(form, input);
        if (state.panelNode.style.display === 'none') {
          return;
        }

        if (event.key === 'ArrowDown') {
          event.preventDefault();
          setPredictiveSelection(state, state.activeIndex + 1);
          return;
        }
        if (event.key === 'ArrowUp') {
          event.preventDefault();
          setPredictiveSelection(state, state.activeIndex - 1);
          return;
        }
        if (event.key === 'Enter' && state.activeIndex >= 0 && state.optionNodes[state.activeIndex]) {
          event.preventDefault();
          window.location.assign(state.optionNodes[state.activeIndex].href);
          return;
        }
        if (event.key === 'Escape') {
          closePredictivePanel(state, false);
        }
      });

      document.addEventListener('mousemove', function (event) {
        var optionNode = event.target instanceof window.Element
          ? event.target.closest('[data-predictive-option]')
          : null;
        if (!(optionNode instanceof window.HTMLAnchorElement)) {
          return;
        }
        var form = optionNode.closest('form');
        if (!isSearchForm(form)) {
          return;
        }
        var input = form.querySelector('input[type="search"]');
        if (!(input instanceof window.HTMLInputElement)) {
          return;
        }
        var state = getPredictiveState(form, input);
        var optionIndex = state.optionNodes.indexOf(optionNode);
        if (optionIndex >= 0) {
          setPredictiveSelection(state, optionIndex);
        }
      });

      document.addEventListener('click', function (event) {
        var panelNodes = document.querySelectorAll('.theme-predictive-search');
        Array.prototype.forEach.call(panelNodes, function (panelNode) {
          if (!(panelNode instanceof window.HTMLElement)) {
            return;
          }
          var parentForm = panelNode.closest('form');
          if (!isSearchForm(parentForm)) {
            return;
          }
          if (panelNode.contains(event.target) || parentForm.contains(event.target)) {
            return;
          }
          var input = parentForm.querySelector('input[type="search"]');
          if (!(input instanceof window.HTMLInputElement)) {
            return;
          }
          closePredictivePanel(getPredictiveState(parentForm, input), false);
        });
      });
    }
  
    function getSectionIdFromNode(node) {
      if (!node || !node.closest) {
        return null;
      }
      var sectionRoot = node.closest('[id^="shopify-section-"]');
      if (!sectionRoot || !sectionRoot.id) {
        return null;
      }
      return sectionRoot.id.replace('shopify-section-', '') || null;
    }
  
    function parseNavigableUrl(rawUrl) {
      try {
        return new window.URL(rawUrl, window.location.origin);
      } catch (error) {
        return null;
      }
    }
  
    function extractSectionInnerHtml(html, sectionId) {
      var temp = document.createElement('div');
      temp.innerHTML = html;
      var wrappedSection = temp.querySelector('#shopify-section-' + sectionId);
      if (wrappedSection) {
        return wrappedSection.innerHTML;
      }
      return html;
    }
  
    function refreshCartSection(options) {
      var opts = options || {};
      var sectionId = opts.sectionId
        || getSectionIdFromNode(document.querySelector('form[name="cart"]'))
        || (document.getElementById('shopify-section-cart-drawer') ? 'cart-drawer' : null);
      if (!sectionId) {
        return Promise.resolve(null);
      }
      var sectionContainer = document.getElementById('shopify-section-' + sectionId);
      if (!sectionContainer) {
        return Promise.resolve(null);
      }
  
      cartRenderRequestId += 1;
      var requestId = cartRenderRequestId;
      sectionContainer.classList.add('is-loading');
      sectionContainer.setAttribute('aria-busy', 'true');
      var focusDescriptor = opts.focusDescriptor || captureFocusDescriptor(document.activeElement);
  
      var requestPath = opts.requestPath || (window.location.pathname + window.location.search);
      var requestUrl = new window.URL(requestPath, window.location.origin);
      requestUrl.searchParams.set('sections', sectionId);

      if (cartRenderAbortController && typeof cartRenderAbortController.abort === 'function') {
        cartRenderAbortController.abort();
      }
      cartRenderAbortController = typeof window.AbortController === 'function'
        ? new window.AbortController()
        : null;
  
      function cleanup() {
        if (requestId === cartRenderRequestId) {
          sectionContainer.classList.remove('is-loading');
          sectionContainer.removeAttribute('aria-busy');
          clearAbortController('cart');
        }
      }
  
      return request(requestUrl.pathname + '?' + requestUrl.searchParams.toString(), {
        signal: cartRenderAbortController ? cartRenderAbortController.signal : undefined,
        responseType: 'section'
      })
        .then(function (payload) {
          if (requestId !== cartRenderRequestId) {
            cleanup();
            return null;
          }
          var renderedSection = payload && payload[sectionId];
          if (!renderedSection) {
            throw new Error('Missing cart section payload: ' + sectionId);
          }
  
          sectionContainer.innerHTML = extractSectionInnerHtml(renderedSection, sectionId);
          restoreFocusFromDescriptor(sectionContainer, focusDescriptor);
          announceLiveRegion('theme-cart-live-region', resolveRuntimeMessage('cart', 'updated'));
  
          if (window.theme && typeof window.theme.initModules === 'function') {
            window.theme.initModules(sectionContainer);
          }

          if (sectionId === 'cart-drawer' && cartDrawerState.initialized) {
            syncCartDrawerSurface();
          }
  
          emit('theme:cart:section:rendered', {
            sectionId: sectionId
          });
          syncCartCount();
          cleanup();
          return true;
        })
        .catch(function (error) {
          if (isAbortError(error)) {
            cleanup();
            return null;
          }
          cleanup();
          if (opts.hardReloadOnError) {
            window.location.reload();
          }
          return null;
        });
    }
  
    function canHandleCollectionNavigation(url) {
      if (!url) {
        return false;
      }
      if (url.origin !== window.location.origin) {
        return false;
      }
      return url.pathname === window.location.pathname;
    }

    function scrollSectionToTop(sectionContainer) {
      if (!(sectionContainer instanceof window.HTMLElement)) {
        return;
      }

      var top = sectionContainer.getBoundingClientRect().top + window.pageYOffset - 24;
      var targetTop = top > 0 ? top : 0;
      var prefersReducedMotion = window.matchMedia
        && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      window.requestAnimationFrame(function () {
        window.scrollTo({
          top: targetTop,
          behavior: prefersReducedMotion ? 'auto' : 'smooth'
        });
      });
    }
  
    function renderCollectionSection(url, options) {
      var opts = options || {};
      var sectionId = opts.sectionId || 'main';
      var fallbackUrl = opts.fallbackUrl || (url.pathname + (url.search || ''));
      var eventName = opts.eventName || 'theme:collection:rendered';
      var sectionContainer = document.getElementById('shopify-section-' + sectionId);
      if (!sectionContainer) {
        window.location.assign(fallbackUrl);
        return Promise.resolve();
      }
  
      collectionRenderRequestId += 1;
      var requestId = collectionRenderRequestId;
      sectionContainer.classList.add('is-loading');
      sectionContainer.setAttribute('aria-busy', 'true');
      var focusDescriptor = Object.prototype.hasOwnProperty.call(opts, 'focusDescriptor')
        ? opts.focusDescriptor
        : captureFocusDescriptor(document.activeElement);
  
      var requestUrl = new window.URL(url.pathname + (url.search || ''), window.location.origin);
      requestUrl.searchParams.set('sections', sectionId);
      var cacheKey = buildSectionCacheKey(sectionId, requestUrl);
      var useCache = opts.useCache !== false;

      if (useCache) {
        var cachedSection = getCachedValue(sectionRenderCache, cacheKey);
        if (cachedSection) {
          sectionContainer.innerHTML = extractSectionInnerHtml(cachedSection, sectionId);
          restoreFocusFromDescriptor(sectionContainer, focusDescriptor);
          if (opts.updateHistory !== false) {
            window.history.pushState(
              { themeCollectionSection: true },
              '',
              url.pathname + (url.search || '')
            );
          }
          if (window.theme && typeof window.theme.initModules === 'function') {
            window.theme.initModules(sectionContainer);
          }
          emit(eventName, {
            url: url.pathname + (url.search || ''),
            sectionId: sectionId,
            cache: true
          });
          if (opts.scrollToTop === true) {
            scrollSectionToTop(sectionContainer);
          }
          sectionContainer.classList.remove('is-loading');
          sectionContainer.removeAttribute('aria-busy');
          return Promise.resolve(true);
        }
      }

      if (collectionRenderAbortController && typeof collectionRenderAbortController.abort === 'function') {
        collectionRenderAbortController.abort();
      }
      collectionRenderAbortController = typeof window.AbortController === 'function'
        ? new window.AbortController()
        : null;
  
      function cleanup() {
        if (requestId === collectionRenderRequestId) {
          sectionContainer.classList.remove('is-loading');
          sectionContainer.removeAttribute('aria-busy');
          clearAbortController('collection');
        }
      }
  
      return request(requestUrl.pathname + '?' + requestUrl.searchParams.toString(), {
        signal: collectionRenderAbortController ? collectionRenderAbortController.signal : undefined,
        responseType: 'section'
      })
        .then(function (payload) {
          if (requestId !== collectionRenderRequestId) {
            cleanup();
            return;
          }
          var renderedSection = payload && payload[sectionId];
          if (!renderedSection) {
            throw new Error('Missing section payload: ' + sectionId);
          }

          setCachedValue(
            sectionRenderCache,
            sectionRenderCacheOrder,
            cacheKey,
            renderedSection,
            SECTION_RENDER_CACHE_LIMIT
          );
  
          sectionContainer.innerHTML = extractSectionInnerHtml(renderedSection, sectionId);
          restoreFocusFromDescriptor(sectionContainer, focusDescriptor);
  
          if (opts.updateHistory !== false) {
            window.history.pushState(
              { themeCollectionSection: true },
              '',
              url.pathname + (url.search || '')
            );
          }
  
          if (window.theme && typeof window.theme.initModules === 'function') {
            window.theme.initModules(sectionContainer);
          }
  
          emit(eventName, {
            url: url.pathname + (url.search || ''),
            sectionId: sectionId,
            cache: false
          });
          if (opts.scrollToTop === true) {
            scrollSectionToTop(sectionContainer);
          }
          cleanup();
        })
        .catch(function (error) {
          if (isAbortError(error)) {
            cleanup();
            return;
          }
          cleanup();
          window.location.assign(fallbackUrl);
        });
    }
  
    function buildNativeCollectionUrl(form) {
      var action = form.getAttribute('action') || window.location.pathname;
      var url = new window.URL(action, window.location.origin);
      var formData = new window.FormData(form);
      var params = new window.URLSearchParams();
  
      formData.forEach(function (value, key) {
        if (value === '' || value === null || value === undefined) {
          return;
        }
        params.append(key, value);
      });
  
      url.search = params.toString();
      return url;
    }

    function buildNativeSearchUrl(form) {
      var action = form.getAttribute('action') || window.location.pathname || '/search';
      var url = new window.URL(action, window.location.origin);
      var formData = new window.FormData(form);
      var params = new window.URLSearchParams();
      var currentUrl = new window.URL(window.location.href);

      if (currentUrl.pathname === url.pathname) {
        currentUrl.searchParams.forEach(function (value, key) {
          if (key === 'q' || key === 'page' || key === 'sections' || key === 'section_id') {
            return;
          }
          params.append(key, value);
        });
      } else if (currentUrl.searchParams.has('preview_theme_id')) {
        params.set('preview_theme_id', currentUrl.searchParams.get('preview_theme_id'));
      }

      formData.forEach(function (value, key) {
        if (value === '' || value === null || value === undefined) {
          return;
        }
        params.delete(key);
        params.append(key, value);
      });

      url.search = params.toString();
      return url;
    }
  
    function shouldHandleClickNavigation(event) {
      if (event.defaultPrevented) {
        return false;
      }
      if (event.button !== 0) {
        return false;
      }
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return false;
      }
      return true;
    }
  
    function bindNativeCollectionFilters() {
      var debouncedFormTimers = new WeakMap();

      function renderFromForm(form, updateHistory, focusDescriptor) {
        var url = buildNativeCollectionUrl(form);
        var sectionId = getSectionIdFromNode(form) || 'main';
        renderCollectionSection(url, {
          sectionId: sectionId,
          fallbackUrl: url.pathname + (url.search || ''),
          updateHistory: updateHistory !== false,
          focusDescriptor: focusDescriptor,
          useCache: true
        });
      }
  
      document.addEventListener('submit', function (event) {
        var form = event.target;
        if (!(form instanceof window.HTMLFormElement)) {
          return;
        }
        if (!form.matches('[data-collection-filter-form]')) {
          return;
        }
        event.preventDefault();
        var existingTimer = debouncedFormTimers.get(form);
        if (existingTimer) {
          window.clearTimeout(existingTimer);
          debouncedFormTimers.delete(form);
        }
        renderFromForm(form, true, captureFocusDescriptor(document.activeElement));
      });
  
      document.addEventListener('change', function (event) {
        var target = event.target;
        if (
          !(target instanceof window.HTMLInputElement) &&
          !(target instanceof window.HTMLSelectElement)
        ) {
          return;
        }
        var form = target.closest('[data-collection-filter-form]');
        if (!(form instanceof window.HTMLFormElement)) {
          return;
        }
        var focusDescriptor = captureFocusDescriptor(target);
        var existingTimer = debouncedFormTimers.get(form);
        if (existingTimer) {
          window.clearTimeout(existingTimer);
        }
        var timer = window.setTimeout(function () {
          renderFromForm(form, true, focusDescriptor);
          debouncedFormTimers.delete(form);
        }, 180);
        debouncedFormTimers.set(form, timer);
      });
  
      document.addEventListener('click', function (event) {
        if (!shouldHandleClickNavigation(event)) {
          return;
        }
        if (!(event.target instanceof window.Element)) {
          return;
        }
  
        var anchor = event.target.closest(
          '[data-native-collection-filters] a[href], [data-collection-pagination] a[href]'
        );
        if (!(anchor instanceof window.HTMLAnchorElement)) {
          return;
        }
  
        var url = parseNavigableUrl(anchor.getAttribute('href'));
        if (!canHandleCollectionNavigation(url)) {
          return;
        }
  
        event.preventDefault();
        var sectionId = getSectionIdFromNode(anchor) || 'main';
        renderCollectionSection(url, {
          sectionId: sectionId,
          fallbackUrl: anchor.href,
          updateHistory: true,
          focusDescriptor: null,
          useCache: true,
          scrollToTop: true
        });
      });
  
      window.addEventListener('popstate', function () {
        var nativeForm = document.querySelector('[data-collection-filter-form]');
        if (!(nativeForm instanceof window.HTMLFormElement)) {
          return;
        }
        var url = new window.URL(window.location.href);
        var sectionId = getSectionIdFromNode(nativeForm) || 'main';
        renderCollectionSection(url, {
          sectionId: sectionId,
          fallbackUrl: url.pathname + (url.search || ''),
          updateHistory: false,
          focusDescriptor: captureFocusDescriptor(document.activeElement),
          useCache: true
        });
      });
    }

    function bindNativeSearchResults() {
      function renderFromSearchForm(form, updateHistory, focusDescriptor) {
        var url = buildNativeSearchUrl(form);
        window.location.assign(url.pathname + (url.search || ''));
      }

      document.addEventListener('submit', function (event) {
        var form = event.target;
        if (!(form instanceof window.HTMLFormElement)) {
          return;
        }
        if (!form.matches('[data-search-form]')) {
          return;
        }

        event.preventDefault();
        renderFromSearchForm(form, true, captureFocusDescriptor(document.activeElement));
      });

      document.addEventListener('click', function (event) {
        if (!shouldHandleClickNavigation(event)) {
          return;
        }
        if (!(event.target instanceof window.Element)) {
          return;
        }

        var anchor = event.target.closest('[data-search-pagination] a[href]');
        if (!(anchor instanceof window.HTMLAnchorElement)) {
          return;
        }

        var url = parseNavigableUrl(anchor.getAttribute('href'));
        if (!canHandleCollectionNavigation(url)) {
          return;
        }

        event.preventDefault();
        window.location.assign(anchor.href);
      });

      window.addEventListener('popstate', function (event) {
        if (window.location.pathname.indexOf('/search') !== 0) {
          return;
        }
        if (!event.state || event.state.themeCollectionSection !== true) {
          return;
        }
        window.location.reload();
      });
    }

    function bindPaginatedSectionNavigation(options) {
      var opts = options || {};
      var paginationSelector = opts.paginationSelector || '';
      var rootSelector = opts.rootSelector || '';
      var defaultSectionId = opts.defaultSectionId || 'main';
      var eventName = opts.eventName || 'theme:section:rendered';
      var shouldHandlePath = typeof opts.shouldHandlePath === 'function'
        ? opts.shouldHandlePath
        : function () {
          return true;
        };

      if (!paginationSelector || !rootSelector) {
        return;
      }

      document.addEventListener('click', function (event) {
        if (!shouldHandleClickNavigation(event)) {
          return;
        }
        if (!(event.target instanceof window.Element)) {
          return;
        }

        var anchor = event.target.closest(paginationSelector + ' a[href]');
        if (!(anchor instanceof window.HTMLAnchorElement)) {
          return;
        }

        var url = parseNavigableUrl(anchor.getAttribute('href'));
        if (!canHandleCollectionNavigation(url)) {
          return;
        }
        if (!shouldHandlePath(url.pathname)) {
          return;
        }

        event.preventDefault();
        var sectionId = getSectionIdFromNode(anchor) || defaultSectionId;
        renderCollectionSection(url, {
          sectionId: sectionId,
          fallbackUrl: anchor.href,
          updateHistory: true,
          eventName: eventName,
          focusDescriptor: captureFocusDescriptor(document.activeElement),
          useCache: true
        });
      });

      window.addEventListener('popstate', function () {
        if (!shouldHandlePath(window.location.pathname)) {
          return;
        }

        var rootNode = document.querySelector(rootSelector);
        if (!(rootNode instanceof window.Element)) {
          return;
        }

        var url = new window.URL(window.location.href);
        var sectionId = getSectionIdFromNode(rootNode) || defaultSectionId;
        renderCollectionSection(url, {
          sectionId: sectionId,
          fallbackUrl: url.pathname + (url.search || ''),
          updateHistory: false,
          eventName: eventName,
          focusDescriptor: captureFocusDescriptor(document.activeElement),
          useCache: true
        });
      });
    }

    function isBlogIndexPath(pathname) {
      return /^\/blogs\/[^/]+\/?$/.test(String(pathname || ''));
    }

    function isArticlePath(pathname) {
      return /^\/blogs\/[^/]+\/[^/]+\/?$/.test(String(pathname || ''));
    }

    function bindBlogResultsSectionRendering() {
      bindPaginatedSectionNavigation({
        paginationSelector: '[data-blog-pagination]',
        rootSelector: '[data-blog-results-root]',
        defaultSectionId: 'main-blog',
        eventName: 'theme:blog:rendered',
        shouldHandlePath: isBlogIndexPath
      });
    }

    function bindArticleCommentsSectionRendering() {
      bindPaginatedSectionNavigation({
        paginationSelector: '[data-article-pagination]',
        rootSelector: '[data-article-comments-root]',
        defaultSectionId: 'main-article',
        eventName: 'theme:article:rendered',
        shouldHandlePath: isArticlePath
      });
    }

    function bindCustomerAddressesSectionRendering() {
      bindPaginatedSectionNavigation({
        paginationSelector: '[data-customer-addresses-pagination]',
        rootSelector: '[data-customer-addresses-root]',
        defaultSectionId: 'main-addresses',
        eventName: 'theme:customer-addresses:rendered',
        shouldHandlePath: function (pathname) {
          return String(pathname || '') === '/account/addresses';
        }
      });
    }
  
    function bindCartChangeLinks() {
      document.addEventListener('click', function (event) {
        if (!shouldHandleClickNavigation(event)) {
          return;
        }
        if (!(event.target instanceof window.Element)) {
          return;
        }
  
        var anchor = event.target.closest('form[name="cart"] a[href*="/cart/change"]');
        if (!(anchor instanceof window.HTMLAnchorElement)) {
          return;
        }
  
        var url = parseNavigableUrl(anchor.getAttribute('href'));
        if (!url || url.origin !== window.location.origin) {
          return;
        }
  
        var line = parseInt(url.searchParams.get('line'), 10);
        var quantity = parseInt(url.searchParams.get('quantity'), 10);
        if (!line || Number.isNaN(line)) {
          return;
        }
        if (Number.isNaN(quantity)) {
          quantity = 0;
        }
  
        event.preventDefault();
        var sectionId = getSectionIdFromNode(anchor) || undefined;
        api.cart.change({
          line: line,
          quantity: quantity
        })
          .then(function () {
            return refreshCartSection({
              sectionId: sectionId,
              hardReloadOnError: true,
              focusDescriptor: captureFocusDescriptor(document.activeElement)
            });
          })
          .catch(function () {
            window.location.assign(anchor.href);
          });
      });
    }

    function onKeyUpEscape(event) {
      if (String(event.code || '').toUpperCase() !== 'ESCAPE') {
        return;
      }

      var openDetailsElement = event.target.closest('details[open]');
      if (!openDetailsElement) {
        return;
      }

      var summaryElement = openDetailsElement.querySelector('summary');
      openDetailsElement.removeAttribute('open');
      if (summaryElement) {
        summaryElement.setAttribute('aria-expanded', 'false');
        summaryElement.focus();
      }
    }

    function initDetailsAccessibility(rootNode) {
      var scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
      var summaries = scope.querySelectorAll('[id^="Details-"] summary');
      Array.prototype.forEach.call(summaries, function (summaryNode) {
        if (!(summaryNode instanceof window.HTMLElement)) {
          return;
        }
        if (summaryNode.dataset.themeA11yBound === '1') {
          return;
        }
        summaryNode.dataset.themeA11yBound = '1';
        summaryNode.setAttribute('role', 'button');
        summaryNode.setAttribute('aria-expanded', summaryNode.parentNode.hasAttribute('open') ? 'true' : 'false');
        if (summaryNode.nextElementSibling && summaryNode.nextElementSibling.getAttribute('id')) {
          summaryNode.setAttribute('aria-controls', summaryNode.nextElementSibling.getAttribute('id'));
        }
        summaryNode.addEventListener('click', function (event) {
          var detailNode = event.currentTarget.closest('details');
          var isOpen = detailNode ? detailNode.hasAttribute('open') : false;
          event.currentTarget.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        });
        summaryNode.parentElement.addEventListener('keyup', onKeyUpEscape);
      });
    }

    function getFocusableElements(container) {
      if (!(container instanceof window.HTMLElement)) {
        return [];
      }
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      );
    }

    var trapFocusHandlers = {};

    function removeTrapFocus(elementToFocus) {
      document.removeEventListener('focusin', trapFocusHandlers.focusin);
      document.removeEventListener('focusout', trapFocusHandlers.focusout);
      document.removeEventListener('keydown', trapFocusHandlers.keydown);
      if (elementToFocus && typeof elementToFocus.focus === 'function') {
        elementToFocus.focus();
      }
    }

    function trapFocus(container, elementToFocus) {
      var focusContainer = container instanceof window.HTMLElement ? container : null;
      if (!focusContainer) {
        return;
      }
      var focusTarget = elementToFocus || focusContainer;
      var elements = getFocusableElements(focusContainer);
      var first = elements[0];
      var last = elements[elements.length - 1];

      removeTrapFocus();

      trapFocusHandlers.focusin = function (event) {
        if (event.target !== focusContainer && event.target !== first && event.target !== last) {
          return;
        }
        document.addEventListener('keydown', trapFocusHandlers.keydown);
      };
      trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', trapFocusHandlers.keydown);
      };
      trapFocusHandlers.keydown = function (event) {
        if (String(event.code || '').toUpperCase() !== 'TAB') {
          return;
        }
        if (event.target === last && !event.shiftKey) {
          event.preventDefault();
          if (first) {
            first.focus();
          }
          return;
        }
        if ((event.target === focusContainer || event.target === first) && event.shiftKey) {
          event.preventDefault();
          if (last) {
            last.focus();
          }
        }
      };

      document.addEventListener('focusout', trapFocusHandlers.focusout);
      document.addEventListener('focusin', trapFocusHandlers.focusin);
      if (focusTarget && typeof focusTarget.focus === 'function') {
        focusTarget.focus();
      }
    }

    function findCartDrawerSurface() {
      var root = document.querySelector('[data-cart-drawer], .cart-drawer');
      if (!(root instanceof window.HTMLElement)) {
        return null;
      }
      var panel = root.querySelector('[data-cart-drawer-panel], .cart-drawer__main, .cart-drawer__contents');
      if (!(panel instanceof window.HTMLElement)) {
        panel = root;
      }
      return {
        root: root,
        panel: panel
      };
    }

    function syncCartDrawerSurface() {
      var surface = findCartDrawerSurface();
      if (!surface) {
        cartDrawerState.root = null;
        cartDrawerState.panel = null;
        cartDrawerState.isOpen = false;
        document.body.classList.remove('cart-drawer-open');
        removeTrapFocus();
        return false;
      }

      cartDrawerState.root = surface.root;
      cartDrawerState.panel = surface.panel;

      if (cartDrawerState.isOpen) {
        surface.root.classList.add('is-open');
        surface.root.setAttribute('aria-hidden', 'false');
        surface.root.setAttribute('data-cart-drawer-state', 'open');
        surface.panel.setAttribute('aria-hidden', 'false');
        document.body.classList.add('cart-drawer-open');
        trapFocus(
          surface.panel,
          surface.panel.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
        );
        return true;
      }

      surface.root.classList.remove('is-open');
      surface.root.setAttribute('aria-hidden', 'true');
      surface.root.setAttribute('data-cart-drawer-state', 'closed');
      surface.panel.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-drawer-open');
      return true;
    }

    function ensureCartDrawerSurface() {
      if (
        cartDrawerState.root instanceof window.HTMLElement
        && cartDrawerState.root.isConnected
        && cartDrawerState.panel instanceof window.HTMLElement
        && cartDrawerState.panel.isConnected
      ) {
        return true;
      }

      return syncCartDrawerSurface();
    }

    function setCartDrawerState(open, options) {
      var opts = options || {};
      if (!ensureCartDrawerSurface()) {
        return;
      }
      if (cartDrawerState.isOpen === open) {
        return;
      }

      cartDrawerState.isOpen = open;
      var root = cartDrawerState.root;
      var panel = cartDrawerState.panel;

      if (open) {
        if (document.activeElement instanceof window.HTMLElement) {
          cartDrawerState.previouslyFocused = document.activeElement;
        } else {
          cartDrawerState.previouslyFocused = null;
        }
        root.classList.add('is-open');
        root.setAttribute('aria-hidden', 'false');
        root.setAttribute('data-cart-drawer-state', 'open');
        panel.setAttribute('aria-hidden', 'false');
        document.body.classList.add('cart-drawer-open');
        trapFocus(panel, panel.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'));
        announceLiveRegion('theme-cart-drawer-live-region', resolveRuntimeMessage('accessibility', 'cartDrawerOpened'));
        emit('theme:cart-drawer:opened', { source: opts.source || 'unknown' });
        return;
      }

      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('data-cart-drawer-state', 'closed');
      panel.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-drawer-open');
      removeTrapFocus();
      if (cartDrawerState.previouslyFocused && typeof cartDrawerState.previouslyFocused.focus === 'function') {
        try {
          cartDrawerState.previouslyFocused.focus({ preventScroll: true });
        } catch (error) {
          cartDrawerState.previouslyFocused.focus();
        }
      }
      announceLiveRegion('theme-cart-drawer-live-region', resolveRuntimeMessage('accessibility', 'cartDrawerClosed'));
      emit('theme:cart-drawer:closed', { source: opts.source || 'unknown' });
    }

    function bindOptionalCartDrawerSupport() {
      if (cartDrawerState.initialized) {
        return !!cartDrawerState.root;
      }

      var surface = findCartDrawerSurface();
      if (!surface) {
        return false;
      }

      cartDrawerState.root = surface.root;
      cartDrawerState.panel = surface.panel;
      syncCartDrawerSurface();
      cartDrawerState.initialized = true;

      document.addEventListener('click', function (event) {
        var target = event.target;
        if (!(target instanceof window.HTMLElement)) {
          return;
        }

        var openTrigger = target.closest('[data-cart-drawer-open], [href="#cart-drawer"], a[href="/cart?view=drawer"]');
        if (openTrigger) {
          event.preventDefault();
          setCartDrawerState(true, { source: 'click-open' });
          return;
        }

        var closeTrigger = target.closest('[data-cart-drawer-close], .cart-drawer__overlay, .cart-drawer__close');
        if (closeTrigger) {
          event.preventDefault();
          setCartDrawerState(false, { source: 'click-close' });
          return;
        }

        if (cartDrawerState.isOpen && target === cartDrawerState.root) {
          event.preventDefault();
          setCartDrawerState(false, { source: 'overlay-click' });
        }
      }, true);

      document.addEventListener('keydown', function (event) {
        if (!cartDrawerState.isOpen) {
          return;
        }
        if (event.key === 'Escape') {
          event.preventDefault();
          setCartDrawerState(false, { source: 'escape' });
        }
      });

      window.addEventListener('theme:cart-drawer:request-open', function () {
        refreshCartSection({
          hardReloadOnError: false,
          sectionId: 'cart-drawer'
        }).finally(function () {
          setCartDrawerState(true, { source: 'event-open' });
        });
      });

      emit('theme:cart-drawer:ready', { supported: true });
      return true;
    }

    function initOptionalFeatureScaffolds() {
      var optional = runtimeFeatureConfig.optionalScaffolds || {};
      if (optional.cartDrawer) {
        emit('theme:optional:cart-drawer:enabled', { supported: bindOptionalCartDrawerSupport() });
      }
      if (optional.pickupAvailability) {
        emit('theme:optional:pickup-availability:enabled', { supported: false });
      }
      if (optional.localization) {
        emit('theme:optional:localization:enabled', { supported: false });
      }
      if (optional.quickOrderList) {
        emit('theme:optional:quick-order-list:enabled', { supported: false });
      }
    }

    function runNonCriticalTask(task) {
      if (typeof task !== 'function') {
        return;
      }

      var runTask = function () {
        try {
          task();
        } catch (error) {
          if (window.console && typeof window.console.error === 'function') {
            window.console.error('[theme-modern] deferred task failed', error);
          }
        }
      };

      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(runTask, { timeout: 1200 });
        return;
      }

      window.setTimeout(runTask, 32);
    }

    function hasDomNodes(selector) {
      if (!selector || typeof selector !== 'string') {
        return false;
      }
      try {
        return !!document.querySelector(selector);
      } catch (error) {
        return false;
      }
    }
  
    function init() {
      if (isInitialized) {
        return;
      }
      isInitialized = true;
  
      patchNetworkHooks();
      bindFallbackAddToCart();
      if (isFeatureEnabled('productEnhancements')) {
        bindVariantGuards();
      }
      if (isFeatureEnabled('predictiveSearch') && hasDomNodes('form[action="/search"] input[type="search"], [data-search-form] input[type="search"]')) {
        runNonCriticalTask(bindPredictiveSearch);
      }
      if (isFeatureEnabled('collectionFilters') && hasDomNodes('[data-collection-filter-form], [data-native-collection-filters], [data-collection-pagination]')) {
        runNonCriticalTask(bindNativeCollectionFilters);
      }
      if (isFeatureEnabled('collectionFilters') && hasDomNodes('[data-search-form], [data-search-pagination], [data-search-results-root]')) {
        runNonCriticalTask(bindNativeSearchResults);
      }
      if (isFeatureEnabled('collectionFilters') && hasDomNodes('[data-blog-results-root], [data-blog-pagination]')) {
        runNonCriticalTask(bindBlogResultsSectionRendering);
      }
      if (isFeatureEnabled('collectionFilters') && hasDomNodes('[data-article-comments-root], [data-article-pagination]')) {
        runNonCriticalTask(bindArticleCommentsSectionRendering);
      }
      if (isFeatureEnabled('collectionFilters') && hasDomNodes('[data-customer-addresses-root], [data-customer-addresses-pagination]')) {
        runNonCriticalTask(bindCustomerAddressesSectionRendering);
      }
      if (
        isFeatureEnabled('cartEnhancements') &&
        window.location.pathname.indexOf('/cart') === 0 &&
        hasDomNodes('form[name="cart"] a[href*="/cart/change"]')
      ) {
        runNonCriticalTask(bindCartChangeLinks);
      }
      if (isFeatureEnabled('accessibilityUtilities')) {
        initDetailsAccessibility(document);
        document.addEventListener('shopify:section:load', function (event) {
          initDetailsAccessibility(event && event.target ? event.target : document);
        });
      }
      runNonCriticalTask(initOptionalFeatureScaffolds);
      runNonCriticalTask(syncCartCount);
    }
  
    window.themeModern = window.themeModern || {};
    window.themeModern.api = api;
    window.themeModern.init = init;
    window.themeModern.refreshCartSection = refreshCartSection;
    window.themeModern.renderProductSectionForVariant = renderProductSectionForVariant;
    window.themeModern.trapFocus = trapFocus;
    window.themeModern.removeTrapFocus = removeTrapFocus;
    window.themeModern.features = runtimeFeatureConfig;
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
}

// [module] src/runtime/entries/theme-modern-core.mjs

registerThemeModernCoreRuntime();

})();
